import React from 'react';
import {
  RatingConfigurator,
  MultipleSelectionConfigurator,
  CommentConfigurator,
  EmailConfigurator,
  SurveyFactory,
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const RSALLMSuggestionOverallSurveyConfig = (options) => {
  const {
    i18n,
  } = options;

  return {
    featureArea: 'RecommendationRSALLMOverallSurvey',
    style: {
      root: {
        maxWidth: 500,
      },
    },
    others: {
      shouldHideInputWhenNotSelected: true,
      userActionAnalysisEnabled: true,
      combineTextInputToComment: true,
      isUserInitiatedSurvey: true,
    },
    rating: {
      isRequired: true,
      Type: RatingConfigurator,
      key: 'rating',
      page: 0,
      position: 0,
      getTitle: () => i18n.getString(_TL_('How satisfied are you with the recommended headlines and descriptions for your responsive search ads?')),
      isVisible: () => true,
      options: [
        {
          key: '5',
          text: i18n.getString(_TL_('Very satisfied')),
          rating: 1.0,
        },
        {
          key: '4',
          text: i18n.getString(_TL_('Moderately satisfied')),
          rating: 0.8,
        },
        {
          key: '3',
          text: i18n.getString(_TL_('Neutral')),
          rating: 0.6,
        },
        {
          key: '2',
          text: i18n.getString(_TL_('Moderately dissatisfied ')),
          rating: 0.4,
        },
        {
          key: '1',
          text: i18n.getString(_TL_('Very dissatisfied')),
          rating: 0.2,
        },
      ],
    },
    email: {
      Type: EmailConfigurator,
      key: 'email',
      page: 1,
      position: 2,
      getTitle: () => i18n.getString(_TL_('Can we follow up with you?')),
      isVisible: answers => ['3', '2', '1'].includes(answers.rating.selectedOption),
      options: [
        {
          key: 'yes',
          text: i18n.getString(_TL_('Yes')),
          placeholder: i18n.getString(_TL_('Email address')),
          hasInput: true,
        },
        {
          key: 'no',
          text: i18n.getString(_TL_('No')),
        },
      ],
    },
    questions: [
      {
        isRequired: true,
        Type: MultipleSelectionConfigurator,
        key: 'q1',
        page: 1,
        position: 0,
        getTitle: () => i18n.getString(_TL_('Please tell us more about why you\'re dissatisfied with recommendations. Select all that apply.')),
        isVisible: answers => ['3', '2', '1'].includes(answers.rating.selectedOption),
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('The recommendations are not relevant.')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('The information isn\'t accurate or up to date.')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('I\'ll need permission from my business or company to use recommended assets.')),
          },
          {
            key: 'q1o4',
            text: i18n.getString(_TL_('Others (please elaborate below)')),
            placeholder: i18n.getString(_TL_('Please feel free to elaborate')),
            hasInput: true,
            maxLength: 2000,
          },
        ],
        data: {
        },
      },
      {
        Type: CommentConfigurator,
        key: 'q2',
        page: 1,
        position: 1,
        getTitle: () => i18n.getString(_TL_('How can we continue to improve?')),
        isVisible: answers => ['3', '2', '1'].includes(answers.rating.selectedOption),
        maxLength: 2000,
        placeholder: i18n.getString(_TL_('Please don\'t include any confidential or personal information in your response.')),
        data: {
        },
      },
    ],
  };
};

export const FactorySurveyView = props => (
  <SurveyFactory
    getSurveyConfiguration={RSALLMSuggestionOverallSurveyConfig}
    {...props}
  />);
